<button class="button paypal-btn" [ngClass]="{ selected: selected }" (click)="doSelectPayPal()">
  <img src="../../../../../assets/icons/paypal-btn.png" />
</button>
